import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/cassa/Cassa.vue'),
		meta: {
			title: 'cassa',
			acl: 'section.cassa'
		}
	}
];

export default routes;